import { useDeferredValue, useMemo } from 'react'

import { useCalendarAndPostsList } from './useCalendarAndPostsList'
import type { PostForCalendarHookResponse } from './useCalendarAndPostsList'
import { useCalendarFilters } from './useCalendarFilters'
import type { CalendarFilters } from './useCalendarFilters'
import { useNavigation } from './useNavigation'
import type { UseNavigationReturn } from './useNavigation'
import { useActiveFilter } from '../CalendarHeader/TypeFilter/useFilterState'

export type CalendarState = {
  postsQuery: PostForCalendarHookResponse
  navigation: UseNavigationReturn
  filters: CalendarFilters
}

export const useCalendarState = (): CalendarState => {
  const navigation = useNavigation()
  const filters = useCalendarFilters()
  const statusFilter = useActiveFilter()

  const navigationDate = navigation.currentDate.getTime()
  const queryDate = useDeferredValue(navigationDate)

  const postsQuery = useCalendarAndPostsList({
    currentDate: queryDate,
    channelsSelected: filters.channelsFilter.queryParams,
    calendarMode: navigation.granularity,
    tagIds: filters.tagsFilter.queryParams,
    status: statusFilter.status,
    postTypes: filters.postTypesFilter.selected,
  })

  const loading = postsQuery.loading || queryDate !== navigationDate

  return useMemo(
    () => ({
      postsQuery: {
        ...postsQuery,
        loading,
      },
      navigation,
      filters,
    }),
    [postsQuery, navigation, filters, loading],
  )
}
